<template>
  <v-app class="bgLightGreen boiler-page customDropdown" id="inspire">
    <Header back header-text="lng_register"></Header>
    <v-container fluid>
      <v-layout row wrap justify-center>
        <v-flex xs12 md6 class="px-4 panel-block">
          <div class="fieldset mt-4">
            <legend class="md-whiteframe-z2" align="center">Register</legend>

            <v-form ref="register" v-model="valid" lazy-validation>
              <v-layout row wrap align-center>
                <v-flex xs7 md7>
                  <span class="subheading title-boil">{{
                    "lng_user_serial" | translate
                  }}</span>
                </v-flex>
                <v-flex xs4 md4>
                  <v-text-field
                    ref="serialNum"
                    v-model="serialNumber"
                    type="Number"
                    required
                    @input="getPrefillInfo"
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout row wrap align-center>
                <v-flex xs7 md7>
                  <span class="subheading title-boil">
                    {{ "lng_user_password" | translate }}
                  </span>
                </v-flex>
                <v-flex xs4 md4 class="cross-icon-p">
                  <v-text-field
                    ref="pass"
                    v-model="password"
                    type="text"
                    :rules="passwordRules"
                    required
                    @input="getPrefillInfo"
                  ></v-text-field>

                  <span
                    v-if="password.length && !validCreds"
                    class="cross-icon-without-p"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fit=""
                      height="100%"
                      width="100%"
                      preserveAspectRatio="xMidYMid meet"
                      focusable="false"
                    >
                      <path
                        d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                      ></path>
                    </svg>
                  </span>
                </v-flex>
              </v-layout>

              <v-layout row wrap align-center>
                <v-flex xs7 md7>
                  <span class="subheading title-boil">
                    {{ "lng_register_password_new" | translate }}
                  </span>
                </v-flex>
                <v-flex xs4 md4>
                  <v-text-field
                    ref="newPass"
                    v-model="newPassword"
                    type="text"
                    :rules="newPasswordRules"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout row wrap align-center>
                <v-flex xs7 md7>
                  <span class="subheading title-boil">
                    {{ "lng_register_password_new_repeat" | translate }}
                  </span>
                </v-flex>
                <v-flex xs4 md4 class="cross-icon-p">
                  <v-text-field
                    ref="repeatPass"
                    v-model="repeatPassword"
                    type="text"
                    :rules="repeatPasswordRules"
                    required
                  ></v-text-field>
                  <p
                    v-if="
                      repeatPassword.length && repeatPassword !== newPassword
                    "
                  >
                    <span class="cross-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fit=""
                        height="100%"
                        width="100%"
                        preserveAspectRatio="xMidYMid meet"
                        focusable="false"
                      >
                        <path
                          d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                        ></path>
                      </svg>
                    </span>
                    <span class="alert-mesage">{{
                      "lng_password_mismatch" | translate
                    }}</span>
                  </p>
                </v-flex>
              </v-layout>

              <v-layout row wrap align-center>
                <v-flex xs7 md7>
                  <span class="subheading title-boil">
                    {{ "lng_register_dealer" | translate }}
                  </span>
                </v-flex>
                <v-flex xs4 md4>
                  <v-autocomplete
                    class="mt-0 pt-0"
                    :items="dealers"
                    :value="selectedDealer.id"
                    v-model="selectedDealer"
                    item-text="name"
                    item-value="value"
                    menu-props="auto"
                    return-object
                    @change="
                      value => {
                        selectedDealer = value;
                      }
                    "
                  ></v-autocomplete>
                  <v-text-field
                    v-if="selectedDealer.id === '0'"
                    :placeholder="
                      'lng_register_other_dealer_placeholder' | translate
                    "
                    ref="otherDealer"
                    v-model="otherDealer"
                    :rules="nameRules"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout row wrap align-center>
                <v-flex xs7 md7>
                  <span class="subheading title-boil">
                    {{ "lng_register_desired_username" | translate }}
                  </span>
                </v-flex>
                <v-flex xs4 md4 class="cross-icon-p">
                  <v-text-field
                    ref="userName"
                    v-model="userName"
                    :rules="usernameRules"
                    required
                    @input="searchUsername"
                  ></v-text-field>
                  <p v-if="!usernameValid">
                    <!-- <v-img
                      class="cross-icon"
                      v-if="!usernameValid"
                      :src="require('../assets/images/icons/svg/ic_close.svg')"
                    ></v-img> -->
                    <span class="cross-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fit=""
                        height="100%"
                        width="100%"
                        preserveAspectRatio="xMidYMid meet"
                        focusable="false"
                      >
                        <path
                          d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                        ></path>
                      </svg>
                    </span>
                    <span class="alert-mesage">{{
                      "lng_username_info" | translate
                    }}</span>
                  </p>
                </v-flex>
              </v-layout>

              <v-layout row wrap align-center>
                <v-flex xs7 md7>
                  <span class="subheading title-boil">
                    {{ "lng_user_name" | translate }}
                  </span>
                </v-flex>
                <v-flex xs4 md4>
                  <v-text-field
                    v-model="name"
                    :rules="nameRules"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout row wrap align-center>
                <v-flex xs7 md7>
                  <span class="subheading title-boil">
                    {{ "lng_user_address" | translate }}
                  </span>
                </v-flex>
                <v-flex xs4 md4>
                  <v-text-field
                    v-model="address"
                    :rules="nameRules"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout row wrap align-center>
                <v-flex xs7 md7>
                  <span class="subheading title-boil">
                    {{ "lng_user_zip" | translate }}
                  </span>
                </v-flex>
                <v-flex xs4 md4>
                  <v-text-field
                    v-model="zipCode"
                    :rules="nameRules"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout row wrap align-center>
                <v-flex xs7 md7>
                  <span class="subheading title-boil">
                    {{ "lng_user_city" | translate }}
                  </span>
                </v-flex>
                <v-flex xs4 md4>
                  <v-text-field
                    v-model="city"
                    :rules="nameRules"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout row wrap align-center>
                <v-flex xs7 md7>
                  <span class="subheading title-boil">
                    {{ "lng_user_country" | translate }}
                  </span>
                </v-flex>
                <v-flex xs4 md4>
                  <v-select
                    class="mt-0 pt-0"
                    :items="countryItems"
                    :value="selectedCountry.value"
                    item-text="name"
                    item-value="value"
                    menu-props="auto"
                    return-object
                    @change="
                      value => {
                        selectedCountry = value;
                      }
                    "
                  ></v-select>
                </v-flex>
              </v-layout>

              <v-layout row wrap align-center>
                <v-flex xs7 md7>
                  <span class="subheading title-boil">
                    {{ "lng_user_email" | translate }}
                  </span>
                </v-flex>
                <v-flex xs4 md4>
                  <v-text-field
                    v-model="email"
                    :rules="emailRules"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout row wrap align-center>
                <v-flex xs7 md7>
                  <span class="subheading title-boil">
                    {{ "lng_register_language" | translate }}
                  </span>
                </v-flex>
                <v-flex xs4 md4>
                  <v-select
                    class="mt-0 pt-0"
                    :items="language"
                    :value="selectedLanguage.value"
                    item-text="name"
                    item-value="value"
                    menu-props="auto"
                    return-object
                    @change="
                      value => {
                        selectedLanguage = value;
                      }
                    "
                  ></v-select>
                </v-flex>
              </v-layout>

              <v-layout row wrap align-center>
                <v-flex xs7 md7>
                  <span class="subheading title-boil">
                    {{ "lng_user_timezone" | translate }}
                  </span>
                </v-flex>
                <v-flex xs4 md4>
                  <v-select
                    class="mt-0 pt-0"
                    :items="timeZone"
                    :value="selectedTimezone.value"
                    item-text="name"
                    item-value="value"
                    menu-props="auto"
                    return-object
                    @change="
                      value => {
                        selectedTimezone = value;
                      }
                    "
                  >
                    <template v-slot:selection="{ item }">
                      <span>{{ item.value }} - {{ item.name }}</span>
                    </template>
                    <template v-slot:item="{ item }">
                      <span>{{ item.value }} - {{ item.name }}</span>
                    </template>
                  </v-select>
                </v-flex>
              </v-layout>

              <p class="warning-text">
                {{ "lng_register_warning" | translate }}
              </p>

              <v-checkbox
                color="rgba(84,110,122,0.87)"
                v-model="nbeProduction"
                :label="'lng_register_terms_contact' | translate"
                required
              ></v-checkbox>

              <v-checkbox v-model="terms" color="rgba(84,110,122,0.87)">
                <template v-slot:label>
                  <div>
                    {{ "lng_register_terms" | translate }}
                    <a
                      target="_blank"
                      href="http://pillefyr.nordjysk-bioenergi.dk/termsdk.txt"
                      @click.stop
                    >
                      {{ "lng_register_terms_1" | translate }}</a
                    >
                    {{ "lng_register_terms_2" | translate }}
                  </div>
                </template>
              </v-checkbox>

              <v-layout row wrap align-center justify-center>
                <v-btn
                  v-if="validCreds && terms"
                  :loading="registerLoading"
                  :disabled="registerLoading"
                  color="primary"
                  class="login-btn mt-0"
                  @click="submitForm"
                  >{{ "lng_register_activate" | translate }}</v-btn
                >
                <v-btn
                  v-else
                  :disabled="true"
                  color="primary"
                  class="login-btn mt-0"
                  >{{ "lng_register_activate" | translate }}</v-btn
                >
              </v-layout>
            </v-form>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    <tech-access-dialog
      :messageText="msgText"
      :openDialog="techDialog"
      :closeDialog="closeTechDialog"
      :giveAccess="closeTechDialog"
    ></tech-access-dialog>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import Header from "../components/Header";
import GlobalService from "../services/global-service";
import UserService from "../services/user-service";
import { countries, languages, timezones } from "../common/Constant";
import TechAccessDialog from "../components/TechAccessDialog";
import router from "../router.js";
import { translate } from "../common/HelperFunctions";

export default {
  components: {
    Header,
    TechAccessDialog
  },
  data: () => ({
    registerLoading: false,
    techDialog: false,
    msgText: "lng_test",
    searchDealer: "",
    dealers: undefined,
    selectedDealer: {},
    valid: false,
    serialNumber: 0,
    password: "",
    newPassword: "",
    repeatPassword: "",
    userName: "",
    otherDealer: "",
    name: "",
    address: "",
    zipCode: "",
    city: "",
    email: "",
    countryItems: countries,
    selectedCountry: {
      name: "Denmark",
      value: "DK"
    },
    language: languages,
    selectedLanguage: {
      name: "Dansk",
      value: "dk"
    },
    timeZone: timezones,
    selectedTimezone: {
      name:
        "Denmark, Amsterdam, Berlin, Bern, Rom, Vienna, Belgrade, Budapest, Paris, Warsaw, Sarajvo, West Central Africa, Sweden and Norway",
      value: "1"
    },
    nbeProduction: false,
    terms: false,
    nameRules: [
      v => !!v || ""
      // v => v.length <= 10 || 'Name must be less than 10 characters'
    ],
    passwordRules: [
      v => !!v || "",
      v => !isNaN(v) || `${translate("lng_accept_numbers")}`
    ],
    emailRules: [v => !!v || "", v => /.+@.+/.test(v) || ""],
    prefillInfo: undefined,
    usernameValid: true,
    validCreds: false
  }),
  async created() {
    // start page loading component
    this.$store.commit("global/setLoading", true);
    await this.FetchApisData();
  },
  mounted() {
    document.getElementsByTagName("html")[0].className = "";
    this.serialNumber = parseInt(this.getUser.name);
  },
  computed: {
    ...mapGetters("user", ["getUser"]),
    newPasswordRules() {
      const rules = [];

      const rule1 = v => !!v || "";
      rules.push(rule1);

      const rule2 = v => v.length >= 8 || `${translate("lng_password_info")}`;
      rules.push(rule2);

      const rule3 = v =>
        (!!v && v) !== this.userName || `${translate("lng_password_info")}`;
      rules.push(rule3);

      // const rule4 = v => !isNaN(v) || `${translate("lng_accept_numbers")}`;
      // rules.push(rule4);

      return rules;
    },
    repeatPasswordRules() {
      const rules = [];

      const rule1 = v => !!v || "";
      rules.push(rule1);

      const rule3 = v => (!!v && v) === this.newPassword || "";
      rules.push(rule3);

      // const rule4 = v => !isNaN(v) || `${translate("lng_accept_numbers")}`;
      // rules.push(rule4);

      return rules;
    },
    usernameRules() {
      const rules = [];

      const rule1 = v => !!v || "";
      rules.push(rule1);

      const rule3 = v => this.usernameValid || "";
      rules.push(rule3);

      return rules;
    }
  },
  watch: {
    userName: function() {
      this.$refs.newPass.validate();
    },
    repeatPassword: function() {
      this.$refs.newPass.validate();
      this.$refs.repeatPass.validate();
    },
    newPassword: function() {
      this.$refs.newPass.validate();
      this.$refs.repeatPass.validate();
    },
    selectedDealer: function(newVal) {}
  },
  methods: {
    async FetchApisData() {
      this.dealers = await GlobalService.getDealers();
      let otherObj = {
        name: translate("lng_register_dealer_other"),
        id: "0"
      };
      this.dealers.unshift(otherObj);
      this.$store.commit("global/setLoading", false);
    },
    async getPrefillInfo() {
      if (this.password && !isNaN(this.password) && this.serialNumber) {
        try {
          this.prefillInfo = await GlobalService.getprefillData(
            this.serialNumber,
            this.password.trim()
          );
          if (this.prefillInfo) {
            this.setPrefillValues(this.prefillInfo);
            this.validCreds = true;
          } else if (this.prefillInfo.status === "error") {
            this.validCreds = false;
            // perform logout and redirect to login
          } else {
            this.resetPrefillValues();
            this.validCreds = false;
          }
        } catch (error) {
          this.resetPrefillValues();
          this.validCreds = false;
        }
      }
    },
    setPrefillValues(values) {
      this.address = values.address;
      this.city = values.city;
      this.email = values.email;
      this.name = values.name;
      this.zipCode = values.zip;
      // this.address = values.phone;
      // this.address = values.country;
    },
    resetPrefillValues() {
      this.address = "";
      this.city = "";
      this.email = "";
      this.name = "";
      this.zipCode = "";
      // this.address = "";
      // this.address = "";
    },
    async searchUsername() {
      this.usernameValid = false;
      if (this.userName && this.userName.length > 0) {
        let format1 = /^(?=.*[a-zA-Z])/; // username value doesn't contain characters
        let format2 = /([A-Z])/; // username value contains upper case letter
        let format3 = /(\s)/; // It has any kind of whitespace
        let format4 = /[!@#$%^&*()~`+\=\[\]{};':"\\|,.<>\/?]+/; // it has some special character
        if (
          !format1.test(this.userName) ||
          format2.test(this.userName) ||
          format3.test(this.userName) ||
          format4.test(this.userName)
        ) {
          this.usernameValid = false;
        } else {
          this.usernameValid = true;
          let searchResult = await GlobalService.usernameSearch(this.userName);
          this.usernameValid = searchResult.status === 0 ? false : true;
        }
      }
    },
    async submitForm() {
      this.registerLoading = true;
      if (
        this.$refs.register.validate() &&
        this.terms &&
        this.nbeProduction &&
        this.selectedDealer.id &&
        this.selectedCountry.value &&
        this.selectedLanguage.value &&
        this.selectedTimezone.value
      ) {
        let register = await GlobalService.registerUser(
          this.address,
          this.nbeProduction,
          this.selectedCountry.value,
          this.selectedCountry.name,
          this.selectedDealer.id,
          this.selectedDealer.id === "0"
            ? this.otherDealer
            : this.selectedDealer.name,
          this.email,
          this.name,
          this.newPassword,
          this.userName,
          this.password,
          this.selectedLanguage.value,
          this.selectedTimezone.value,
          this.city,
          this.serialNumber,
          this.zipCode
        );
        if (register.status === "0") {
          this.login();
          this.registerLoading = false;
        } else {
          this.registerLoading = false;
          this.openTechDialog("Oops! Something went wrong.");
        }
      } else {
        this.registerLoading = false;
        this.openTechDialog(`${translate("lng_register_warning")}`);
      }
    },
    // login function
    async login() {
      let response;
      try {
        response = await UserService.login(this.userName, this.newPassword);
      } catch (e) {
        this.error = "Try again later!!";
      }
      if (!response.status) {
        this.$store.commit("user/setUser", {
          name: this.userName,
          token: response.token,
          master: response.master,
          credentials: response.credentials
        });
        localStorage.setItem(
          "user",
          JSON.stringify({
            name: this.userName,
            token: response.token,
            master: response.master,
            credentials: response.credentials
          })
        );
        router.push("/system/settings/map");
      } else {
        this.openTechDialog("Oops! Something went wrong.");
      }
    },
    openTechDialog(text) {
      this.msgText = text;
      this.techDialog = true;
    },
    closeTechDialog() {
      this.techDialog = false;
    }
  }
};
</script>
<style>
.v-text-field {
  padding-top: 0px;
}
.warning-text {
  font-size: 12px;
  letter-spacing: 0.02em;
}
.v-label {
  color: #000 !important;
}
.v-label a {
  color: -webkit-link;
}
.alert-mesage {
  font-size: 10px;
  line-height: 12px;
  text-align: right;
  color: #dd2c00;
  float: left;
  margin-top: -5px;
  width: 100%;
}
.cross-icon {
  fill: #f44336;
  width: 20px;
  height: 20px;
  position: absolute;
  left: -29px;
}
.cross-icon-p {
  position: relative;
}
.cross-icon-without-p {
  fill: #f44336;
  width: 20px;
  height: 20px;
  position: absolute;
  left: -29px;
  bottom: 15px;
}
@media (max-width: 480px) {
  .customDropdown .v-select__selections * {
    max-width: 70px !important;
  }
}
</style>
